// extracted by mini-css-extract-plugin
module.exports = {"root":"NavigationMenu_root__3wYas","icon":"NavigationMenu_icon__lwPiR"};